import Swiper from 'swiper';
import { Navigation, Keyboard, Mousewheel, A11y } from 'swiper/modules';

/**
 * Shared setup for the site's carousels, so they all behave alike: arrows
 * (<x-carousel-arrows>, found inside `scope`) that hide when every slide fits,
 * left/right keys while the carousel is on screen, horizontal trackpad swipes
 * (vertical scrolling still scrolls the page), a grab cursor and screen
 * reader labels. Anything in `options` overrides these, and extra modules are
 * added to the defaults.
 *
 * @param {HTMLElement} el     the .swiper element
 * @param {HTMLElement} scope  an element containing the arrows
 * @param {object} options     Swiper options, plus `label` (the slide noun, e.g. "photo")
 */
export function carousel(el, scope, options = {}) {
  const { label = 'slide', modules = [], ...rest } = options;
  const prevEl = scope ? scope.querySelector('[data-carousel-prev]') : null;
  const nextEl = scope ? scope.querySelector('[data-carousel-next]') : null;

  return new Swiper(el, {
    grabCursor: true,
    watchOverflow: true,
    speed: 600,
    keyboard: { enabled: true, onlyInViewport: true },
    mousewheel: { forceToAxis: true },
    a11y: { prevSlideMessage: `Previous ${label}`, nextSlideMessage: `Next ${label}` },
    navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
    ...rest,
    modules: [Navigation, Keyboard, Mousewheel, A11y, ...modules],
  });
}
